import { Roles } from "@/models/user/roles";
import { PartialNetSuiteCustomer, PriceLevel } from "@/models/netsuite/netsuite";
import { SSOImpersonation } from "@/services/auth_service";
import { GlobalState } from "./types";

export const setLoading = (state: GlobalState, value: boolean) => {
  state.isLoading = value;
};

export const setLoggedIn = (state: GlobalState, value: boolean) => {
  state.isLoggedIn = value;
};

export const setRole = (state: GlobalState, value: Roles | null) => {
  state.userRole = value;
};

export const setMobile = (state: GlobalState, value: boolean) => {
  state.isMobile = value;
};

export const setTablet = (state: GlobalState, value: boolean) => {
  state.isTablet = value;
};

export const setMultiplier = (state: GlobalState, value: PriceLevel | null) => {
  state.multiplier = value;
};

export const setPriceLevels = (state: GlobalState, value: PriceLevel[]) => {
  state.priceLevels = value;
};

export const setCustomers = (state: GlobalState, value: PartialNetSuiteCustomer[]) => {
  state.customers = value;
};

export const setAuthToken = (state: GlobalState, value: string | null) => {
  state.authToken = value;
};

export const setImpersonation = (state: GlobalState, value: SSOImpersonation | null) => {
  state.impersonation = value;
};
